import Vue from 'vue';

// Bootstrap installation
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import 'bootstrap-icons/font/bootstrap-icons.css';

// Multiselect installation
import 'vue-multiselect/dist/vue-multiselect.min.css';
import '@/styles/multiselect.less'; // custom multiselect style

// Markdown editor css
import '@toast-ui/editor/dist/toastui-editor.css';

// Maplibre
import 'maplibre-gl/dist/maplibre-gl.css';

// Custom css
import '@/styles/app.scss';
import '@/styles/app.less';
import '@/styles/app.css';
import 'github-markdown-css/github-markdown-light.css';
import { initMatomoFromConfig, initMatomoRouterTracking } from './utils/matomo.js';
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

import App from '@/App.vue';

import sanitizer from './utils/sanitizer.js';
import store from '@/store';
import router from '@/router.js';
import { userSession } from '@/api/modules/login.api.js';
import { currentDomainOrganisation } from '@/api/modules/app.api.js';
import {
  currentUsergroupMembers,
  usergroupRoles
} from '@/api';

Vue.config.productionTip = false;

import { capitalizeFirstLetter } from '@/utils';
import Config from './services/config.service';

const config = new Config();
import i18n from '@/common/i18n/i18n.js';
/** Charge les WC portal header/footer. Accepte `true` ou `{ header_url, footer_url }`. */
function loadCustomHeaderFooterScripts(customHeaderAndFooter) {
  if (!customHeaderAndFooter) {
    return;
  }

  const headElement = document.getElementsByTagName('head')[0];
  if (!headElement) {
    return;
  }

  const cfg = typeof customHeaderAndFooter === 'object' ? customHeaderAndFooter : {};

  const headerScript = document.createElement('script');
  headerScript.type = 'text/javascript';
  headerScript.src = cfg.header_url || '/portal/wc/ogs-header.js';
  headElement.append(headerScript);

  const footerScript = document.createElement('script');
  footerScript.type = 'text/javascript';
  footerScript.src = cfg.footer_url || '/portal/wc/ogs-footer.js';
  headElement.append(footerScript);
}

loadCustomHeaderFooterScripts(config.customHeaderAndFooter);
Vue.config.ignoredElements = ['ogs-header', 'ogs-footer'];
Vue.mixin({
  data() {
    return {
      currentDomainOrganisation,
      currentUsergroupMembers,
      usergroupRoles,
      userSession,
    };
  },
  computed: {
    isUserAuthenticated() {
      return userSession.isUserAuthenticated;
    },
    userData() {
      return userSession.userData;
    },
  },
  methods: {
    isFieldVisible(field, hiddenFields) {
      return !hiddenFields.includes(field);
    },
    isFieldRequired(field, requiredFields) {
      return requiredFields.includes(field) ? 'required' : '';
    },
    getIconPath(iconName) {
      const icon = require.context('@/assets/icons/', false, /\.svg$/);
      return icon(`./${iconName}.svg`);
    }
  }
});

Vue.directive('sanitize', {
  bind: sanitizer
});

if (config.statistics.matomoHost.length > 0 && config.statistics.matomoId) {
  initMatomoFromConfig(config.statistics.matomoHost, config.statistics.matomoId);
  initMatomoRouterTracking(router);
}

Vue.prototype.$config = config;
Vue.prototype.capitalizeFirstLetter = capitalizeFirstLetter;

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');